module.exports = __webpack_public_path__ + "static/media/steve_einfuehrung.c6a12503.pdf";